/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["entathakusa", "ekuseni", "emini", "ntambama", "ebusuku"], u, u], u, [["00:00", "06:00"], ["06:00", "10:00"], ["10:00", "13:00"], ["13:00", "19:00"], ["19:00", "24:00"]]];
